<!--
 * @Author: 朱占伟
 * @LastEditors: 陈振鹏 1216971989@qq.com
 * @description: 支付渠道列表
 * @Date: 2021-09-10 14:31:50
 * @LastEditTime: 2023-05-29 19:16:38
-->
<template>
  <div class="payTypes-payment-list mt-5 mb-10">

    <PayTypeInfo 
      :state="state"
      :valid="valid"
      :promo-code="promoCode"
      :reward="reward"
      :added-promo-code="addedPromoCode"
      :use-list="useList"
      :un-use-list="unUseList"
      @openAction="openAction"
      @payTypeChange="payTypeChange"
      @handleClickPayType="handleClickPayType"
    />

    <!-- promo code popup -->
    <van-action-sheet
      v-model:show="popupShow"
      closeable
      @open="handleOpenPopup"
      @close="clearPromoInfo"
      title="Promo Code"
      :style="{ height: '450px' }"
      :lock-scroll="false"
      :immediate-check="false"
    >
      <div v-if="popupShow" class="action-wrap">
        <!-- <div class="button-group">
          <button :class="tabsName === 'Ava' ? 'is-active' : ''" @click="checkTabs('Ava')">Available</button>
          <button :class="tabsName === 'UnAva' ? 'is-active' : ''" @click="checkTabs('UnAva')">Unavailable</button>
        </div> -->
        <div class="promo-code-dialog-title">Available(<span style="color: #6153FF;">{{ pList.length }}</span>)</div>
        <div class="promo-code-dialog-wrap">
          <div v-if="pList.length > 0">
            <div
              v-for="item in pList"
              :key="item._id"
              style="margin-bottom: 16px"
              class="promo-code-content"
              @click="isCheck(item.code)"
            >
              <div class="promo-code-item promo-code-info">
                <div class="promo-code-item-left">
                  <div class="promo-code-code">Code:{{ item.code }}</div>
                  <div class="promo-code-date">
                    <div v-if="item.validType === 1" class="promo-date">
                      Valid Date: {{ formatTime(item.validStart) }} ~
                      {{ formatTime(item.validEnd) }}(UTC+8)
                    </div>
                    <div v-if="item.validType === 2" class="promo-date">
                      Valid Date: Within {{ item.validDays }} days after
                      receiving
                    </div>
                  </div>
                </div>
                <div style="display: flex; column-gap: 10px">
                  <div class="promo-code-item-right">
                    <div
                      v-if="item.sill && item.sill !== 0"
                      class="promo-code-sill"
                      style="margin-bottom: 5px"
                    >
                      Top-up over<br>
                      {{ item.sill / 100 }}
                    </div>
                    <div class="promo-code-reward">
                      <div
                        v-if="item.offerType === 1"
                        class="promo-code-reward-left"
                      >
                        <div>$</div>
                      </div>
                      <div class="promo-code-reward-count">
                        {{ item.reward / 100 }}
                      </div>
                      <div
                        v-if="item.offerType === 2"
                        class="promo-code-reward-right"
                      >
                        <div class="promo-code-reward-right-up">OFF</div>
                        <div class="promo-code-reward-right-down">%</div>
                      </div>
                    </div>
                  </div>

                  <div class="promo-code-check">
                    <van-button
                      v-if="tabsName === 'Ava'"
                      round
                      type="info"
                      :icon="promoCode === item.code ? 'success' : ''"
                      class="plusBtn"
                      :class="promoCode === item.code ? 'is-active' : ''"
                    />
                    <div v-if="tabsName === 'UnAva'" class="un-title" />
                  </div>
                </div>
              </div>

              <div id="border" />

              <div class="promo-code-item promo-code-until">
                <div style="width: 100%">
                  <div
                    class="promo-code-detail"
                    tabindex="0"
                    @click="openDetails($event, item.serviceStr, item._id)"
                  >
                    <div>Rules of Use</div>
                    <img :src="codeArrow" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-title">
            {{
              tabsName === "Ava"
                ? "No available promo code"
                : "No unavailable promo code"
            }}
          </div>
        </div>

        <div class="promo-code-dialog-title">Unavailable(<span style="color: #6153FF;">{{ unUseList.length }}</span>)</div>
        <div class="promo-code-dialog-wrap">
          <div v-if="unUseList.length > 0">
            <div />
            <div
              v-for="item in unUseList"
              :key="item._id"
              style="margin-bottom: 16px"
              class="promo-code-content is-no-use"
              @click="isCheck(item.code)"
            >
              <div class="promo-code-item promo-code-info">
                <div class="promo-code-item-left">
                  <div class="promo-code-code">Code:{{ item.code }}</div>
                  <div class="promo-code-date">
                    <div v-if="item.validType === 1" class="promo-date">
                      Valid Date: {{ formatTime(item.validStart) }} ~
                      {{ formatTime(item.validEnd) }}(UTC+8)
                    </div>
                    <div v-if="item.validType === 2" class="promo-date">
                      Valid Date: Within {{ item.validDays }} days after
                      receiving
                    </div>
                  </div>
                </div>
                <div style="display: flex; column-gap: 10px">
                  <div class="promo-code-item-right">
                    <div class="promo-code-sill">
                      <div
                        v-if="item.sill && item.sill !== 0"
                        class="promo-code-sill"
                        style="margin-bottom: 5px"
                      >
                        Top-up over<br>
                        {{ item.sill / 100 }}
                      </div>
                    </div>
                    <div class="promo-code-reward">
                      <div
                        v-if="item.offerType === 1"
                        class="promo-code-reward-left"
                      >
                        <div>$</div>
                      </div>
                      <div class="promo-code-reward-count">
                        {{ item.reward / 100 }}
                      </div>
                      <div
                        v-if="item.offerType === 2"
                        class="promo-code-reward-right"
                      >
                        <div class="promo-code-reward-right-up">OFF</div>
                        <div class="promo-code-reward-right-down">%</div>
                      </div>
                    </div>
                  </div>

                  <div class="promo-code-check">
                    <div class="un-title" />
                  </div>
                </div>
              </div>

              <div id="border" />

              <div class="promo-code-item promo-code-until">
                <div style="width: 100%">
                  <div
                    class="promo-code-detail"
                    tabindex="0"
                    @click="openDetails($event, item.serviceStr, item._id)"
                  >
                    <div>Rules of Use</div>
                    <img :src="codeArrow" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-title">
            {{
              tabsName === "Ava"
                ? "No available promo code"
                : "No unavailable promo code"
            }}
          </div>
        </div>
        <div class="confirm-btn">
          <van-button @click="confirmPromoCode">Confirm</van-button>
        </div>
      </div>
    </van-action-sheet>
    <van-popup
      :show="detailsShow"
      position="bottom"
      closeable
      round
      :lock-scroll="false"
      :immediate-check="false"
      @close="closeDetails"
    >
      <div class="popup-wrap-de">
        <div class="popup-title-de">Rules</div>
      </div>
      <div class="server-details-content">
        <div style="margin-bottom: 10px">
          Applicable service: {{ detailsServer }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// promo code valid
const status = {
  EXPIRE: "The promo code has expired",
  REACH_LIMIT: "The code usage limit has been reached",
  BAD_PRICE: "The Promo code does not meet the requirements for the use",
  INVALID: "Invalid promo code",
  VALID: "You will receive a bonus of $ 50.00",
};
import { payTypeListInfo } from "./data";
import {
  inject,
  onMounted,
  reactive,
  ref,
  toRefs,
  watch,
  watchEffect,
} from "vue";
import { useStore } from "vuex";
import { getPayType, usePromoCode } from "model/campaign";
import { getPromocodeList } from "model/promocode";
import PayTypeInfo from "./PayTypeInfo.vue";
// common js
import { formatTime } from "model/common";
//icon
import codeArrow from "assets/images/promocode/promo_code_details_arrow.svg";
import { getCurrentInstance } from "vue";
export default {
  props: {
    selectPayInfo: {
      type: Object,
      default: () => null,
    },
    rechargeForm: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    PayTypeInfo
  },

  setup(props, { emit }) {
    const store = useStore();
    const _ = inject("_");
    const _PromoCode = inject("_PromoCode");
    const state = ref({
      selectPay: "PAY_PAL",
      maxAmount: null,
      list: [],
    });

    const detailState = reactive({
      detailsShow: false,
      detailsServer: null,
    });

    const popupShow = ref(false);
    const promoCode = ref(null);
    const promoCodeMessage = ref(null);
    const amount = ref(null);
    const valid = ref(false);
    const addedPromoCode = ref(null);
    const localSelectPayInfo = ref(null);
    watchEffect(() => {
      amount.value = props?.rechargeForm?.money ?? null;
      localSelectPayInfo.value = props?.selectPayInfo ?? null;

      valid.value = props?.rechargeForm?.valid;
      // promoCodeMessage.value=status[props?.rechargeForm ?.validErrorType]||''
      // promoCode.value = null
      // addedPromoCode.value = null
    });

    watch(addedPromoCode, (newV) => {
      emit("change-promo-code", newV ?? null);
    });
    
    const addMaxAmount = (list) => {
      list.forEach((item) => {
        if (item.payType === "PAYSSION_DOKU") {
          item.maxAmount = 340;
        } else if (item.payType === "PAYSSION_KAKAOPAY_KR") {
          item.maxAmount = 350;
        } else if (item.payType === "PAYSSION_EBANKING_KR") {
          item.maxAmount = 420;
        } else if (item.payType === 'AIRWALLEX_DOKU_WALLET') {
          item.maxAmount = 650
        } else if (
          item.payType === "PAYSSION_ATM" ||
          item.payType === "PAYSSION_DANA" ||
          item.payType === "PAYSSION_LINK_AJA"
        ) {
          item.maxAmount = 690;
        } else if (item.payType === 'AIRWALLEX_KAKAO_PAY') {
          item.maxAmount = 700;
        } else if (item.payType === "PACY_PAY") {
          item.maxAmount = 800;
        } else if (
          item.payType === "PAYSSION_E_WALLET" ||
          item.payType === "PAYSSION_NET_BANKING" ||
          item.payType === "PAYSSION_UPI"
        ) {
          item.maxAmount = 1000;
        } else if (item.payType === 'AIRWALLEX_DANA') {
          item.maxAmount = 1200;
        } else if (
          item.payType === "PAYSSION_BITCOIN"
        ) {
          item.maxAmount = 1450;
        } else if (
          item.payType === "PASS_PAY" ||
          item.payType === "GLOCASH" ||
          item.payType === "ALL_PAY"
        ) {
          item.maxAmount = 1500;
        } else if (item.payType === "PAYOP") {
          item.maxAmount = 900;
        } else if (
          item.payType === "PAYOP_BITCOIN" ||
          item.payType === "PAYOP_BITCOINCASH" ||
          item.payType === "PAYOP_LITECOIN" ||
          item.payType === "PAYOP_ETHEREUM"
        ) {
          item.maxAmount = 2000;
        } 
        else if (
          item.payType === 'PAYONEER'
        ) {
          item.maxAmount = 10000
        } 
        else if (
          item.payType === 'CRYPTOMUS'
        ) {
          item.maxAmount = 1000000
        }
      });
      return list;
    };

    let checked = ref("");
    /**** api:获取支付渠道列表数据 */
    const getPayTypes = async () => {
      let list = [];
      const re = await getPayType();
      if (re.code === 0) {
        list = re.data;
      }
      store.dispatch("savePayTypes", list);
      state.value.selectPay = list && list[0].payType;
      checked.value = list[0].payType;
      state.value.list = list;
      emit(
        "select",
        state.value.selectPay,
        list.find((item) => item.payType === state.value.selectPay).maxAmount || 0
      );
      addMaxAmount(state.value.list);
    };
    const sendMaxAmount = (val) => {
      emit("sendMaxAmount", val);
    };

    //点击单元格 即选中单选框
    const getCheckedValue = (val) => {
      state.value.selectPay = val;
      checked.value = state.value.selectPay;
    };
    //初始化获取支付渠道列表
    getPayTypes();

    // 打开优惠码弹出层
    const handleOpenPopup = async () => {
      // if(props.rechargeForm.validType==='click'){
      //   await validPromoCode()
      // }
      if (props.rechargeForm.validType === "input") {
        promoCode.value = addedPromoCode.value;
        if (!valid.value && props.rechargeForm.validErrorType !== "INVALID") {
          promoCodeMessage.value = status[props?.rechargeForm?.validErrorType];
        } else {
          promoCodeMessage.value = "";
        }
      } else {
        if (!valid.value) {
          promoCode.value = null;
          valid.value = false;
        } else {
          promoCode.value = addedPromoCode.value;
        }
        promoCodeMessage.value = null;
      }
      if (!promoCode.value) {
        promoCodeMessage.value = null;
      }
    };

    // 校验优惠码
    const reward = ref(null);
    const validPromoCode = async () => {
      if (!promoCode.value || !promoCode.value.length) {
        emit("getPromoReward", "");
        valid.value = false;
        return;
      }
      const res = await usePromoCode({
        code: promoCode.value,
        amount: Number(amount.value) * 100,
      });

      if (res.reward) {
        valid.value = true;
        reward.value = res.reward / 100;
      } else {
        valid.value = false;
        promoCodeMessage.value = status[res.codeError];
        reward.value = 0;
      }
      emit("getPromoReward", reward.value);
    };

    const handleClickPayType = (item) => {
      state.value.selectPay = item?.payType;
      emit("sendMaxAmount", item?.maxAmount);
      // checkFirstPromoCode(promoState.useList)
      validPromoCode();
    };

    // 添加优惠码
    const handleAddPromoCode = async (code) => {
      emit("getValidType", "click");
      await validPromoCode();
      const validCode = valid.value ? code : null;
      addedPromoCode.value = validCode;
      emit("change-promo-code", validCode);
      if (valid.value || !promoCode.value || !promoCode.value.length) {
        popupShow.value = false;
      }
    };

    const clearPromoInfo = () => {
      if (!valid.value && props?.rechargeForm?.validType !== "input") {
        promoCode.value = "";
        promoCodeMessage.value = "";
      }
    };
    watch(
      () => props.rechargeForm.validErrorType,
      () => {
        if (props.rechargeForm.validErrorType) {
          promoCodeMessage.value =
            status[props?.rechargeForm?.validErrorType] || "";
        }
      }
    );

    //  new Promocode

    const promoState = reactive({
      tabsName: "Ava",
      promoCheck: true,
      type: 1,
      count: 0,
      pList: [],
      useList: [],
      unUseList: [],
    });

    watch(
      amount,
      _.debounce((newv, oldv) => {
        promoState.type = 1;
        promoState.tabsName = "Ava";
        getPromoCode();
      }, 500)
    );

    const isCheck = (e) => {
      // @click="onComfirmCompletedClick"
      if (promoCode.value === e) {
        promoCode.value = "";
        return;
      }
      promoCode.value = e;
    };
    // const checkTabs = (val) => {
    //   promoState.tabsName = val
    //   if (val === 'Ava') {
    //     promoState.pList = promoState.useList
    //     promoState.type = 1
    //   } else {
    //     promoState.pList = promoState.unUseList
    //     promoState.type = 2
    //   }
    // }

    const isSend = ref(false);

    // const myRefs = new Map()
    // const domMap = new Map()
    // const setRef = (el) => {
    //   console.log(el)
    //   console.log(el.getAttribute('aria-describedby'))
    //   myRefs.set(el.getAttribute('aria-describedby'), el)
    // }
    // const showPromoDetails = (id, ite) => {
    //   if(domMap.get(id)){
    //     myRefs.get(id).removeChild(domMap.get(id))
    //     domMap.delete(id)
    //     return
    //   }
    //   const divDom = document.createElement('div')
    //   divDom.className = 'promo-code-tips'
    //   divDom.innerHTML = `
    //     <p>Applicable service: ${'Add Money'}</p>
    //     <p>Rules of use: Not shared with preferential prices, agreement prices, 50% off the first order, and other promo codes.</p>
    //   `
    //   domMap.set(id, divDom)
    //   myRefs.get(id).appendChild(divDom)
    // }

    const formatPList = (list) => {
      if (!(list.length > 0)) return [];
      const handleList = list.map((ite) => {
        return {
          ...ite,
          serviceStr: _PromoCode.typeListToString(ite.offerType, ite.services),
        };
      });
      return handleList;
    };

    const getPromoCode = async (e = amount.value) => {
      if (isSend.value) {
        return;
      }
      isSend.value = true;
      let params = {
        type: 1,
        offerType: 1,
        amount: e ? Number(e) * 100 : 0
      };
      const res = await getPromocodeList(params);
      if (res) {
        promoState.useList = res.available || [];
        promoState.unUseList = res.unAvailable || [];
        promoState.useList.sort((a, b) => {
          if (a.reward > b.reward) {
            return -1;
          } else {
            return 1;
          }
        });
        promoState.useList = formatPList(promoState.useList);
        promoState.unUseList.sort((a, b) => {
          if (a.reward > b.reward) {
            return -1;
          } else {
            return 1;
          }
        });
        promoState.unUseList = formatPList(promoState.unUseList);
        promoState.pList = promoState.useList;
      }
      isSend.value = false;
      checkFirstPromoCode(promoState.useList);
    };

    const confirmPromoCode = async () => {
      await validPromoCode();
      const validCode = valid.value ? promoCode.value : null;
      addedPromoCode.value = validCode;
      emit("change-promo-code", validCode);
      if (valid.value || !promoCode.value || !promoCode.value.length) {
        popupShow.value = false;
      }
    };

    const checkFirstPromoCode = (e) => {
      promoCode.value = e.length > 0 ? e[0].code : null;
      confirmPromoCode();
    };

    const openAction = (e) => {
      popupShow.value = true;
      e.stopPropagation();
    };

    const openDetails = ($event, data) => {
      $event.stopPropagation();
      if (detailState.detailsShow) {
        detailState.detailsShow = false;
        setTimeout(() => {
          detailState.detailsShow = true;
          detailState.detailsServer = data;
        }, 400);
        return;
      }
      detailState.detailsServer = data;
      detailState.detailsShow = true;
    };
    const closeDetails = () => {
      detailState.detailsShow = false;
      detailState.detailsServer = null;
    };
    /****切换支付渠道 */
    const {proxy} = getCurrentInstance()
    const payTypeChange = async () => {
      emit(
        "select",
        state.value.selectPay,
        state.value.list.find((item) => item.payType === state.value.selectPay)?.maxAmount
      );
      if (proxy.$parent.selectPayInfo && proxy.$parent.selectPayInfo.onSelect) {
        await proxy.$parent.selectPayInfo.onSelect.apply(
          proxy.$parent,
          proxy.$parent.selectPayInfo,
          proxy.$parent.rechargeForm
        );
      }
    }

    onMounted(() => {
      getPromoCode();
    });

    return {
      validPromoCode,
      state,
      addMaxAmount,
      sendMaxAmount,
      checked,
      getCheckedValue,
      popupShow,
      promoCode,
      promoCodeMessage,
      handleOpenPopup,
      valid,
      handleClickPayType,
      addedPromoCode,
      reward,
      clearPromoInfo,
      ...toRefs(promoState),
      ...toRefs(detailState),
      isCheck,
      formatTime,
      confirmPromoCode,
      openAction,
      openDetails,
      closeDetails,
      payTypeChange
    };
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>
// 支付列表
.radio-group {
  padding-left: 10px;
  border-bottom: 1px solid #ebeef5;
  .radio-group_title {
    width: 80%;
  }
  .radio-group-content {
    position: relative;
    padding: 0 10px;
    height: 50px;
    line-height: 50px;

    .van-radio {
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -10px;
    }
  }
  .radio-group-sheet {
    padding: 10px;
    background: #f9f9f9;
    text-align: right;
    a {
      text-decoration: underline;
    }
  }
}

.button-group {
  width: max-content;
  margin: 0 auto;
  margin-bottom: 20px;
  border: 1px solid #6153ff;
  border-radius: 18px 18px 18px 18px;
  button {
    padding: 7px 25px;
    background: transparent;
    font-weight: bold;
    color: #6153ff;
    font-family: PingFang SC-Bold, PingFang SC;
    cursor: pointer;

    &.is-active {
      color: #ffffff;
      background: #6153ff;
      border-radius: 18px 18px 18px 18px;
    }
  }
  & > button:first-child {
    border: unset;
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
  }
  & > button:last-child {
    border: unset;
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;
  }
}

.action-wrap {
  max-height: 340px;
  overflow-y: auto;
}

.promo-code-dialog-wrap {
//   max-height: 280px;
  padding-bottom: 50px;

  .un-title {
    font-size: 28px;
    font-family: Segoe UI-Semibold, Segoe UI;
    font-weight: 600;
    color: #b6b0f1;
    transform: rotate(-90deg) translateY(-75%);
    width: max-content;
  }

  .promo-code-content {
    position: relative;
    column-gap: 24px;
    width: 354px;
    height: 158px;
    margin: 0 auto;
    margin-bottom: 10px;
    padding: 16px 20px 0px;
    background-image: url("assets/images/promocode/promo-code-bg-new2.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
    color: #ffffff;
    transform: scale(0.9);

    &.is-no-use {
  background-image: url("assets/images/promocode/promo-code-bg-ban.png");
    }
  }
  .promo-code-content2 {
    background-image: url("assets/images/promocode/promo-code-bg-new1.png");
  }

  #border {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.7) 0%,
      rgba(255, 255, 255, 0.7) 50%,
      transparent 50%
    );
    background-size: 14px 1px;
    background-repeat: repeat-x;
  }

  .promo-code-item {
    display: flex;
    justify-content: space-between;
  }
  .promo-code-info {
    min-height: 105px;
    //   border-bottom: 1px dashed rgba($color: #fff, $alpha: .7);
  }
  .promo-code-until {
    width: 100%;
    height: 46px;
    align-items: center;
  }
  .promo-code-item-left {
    max-width: 184px;
  }
  .promo-code-item-right {
    max-width: 115px;
  }
  // .promo-code-item-left > div,.promo-code-item-right > div {
  //   margin-bottom: 10px;
  // }

  .promo-code-code {
    font-size: 16px;
    font-family: Arial-Regular, Arial;
    font-weight: 400;
    min-height: 36px;
    word-break: break-all;
    margin-bottom: 4px;
  }
  .promo-code-date {
    font-size: 12px;
    color: rgba($color: #fff, $alpha: 0.7);
  }
  .promo-code-sill {
    font-size: 14px;
    font-family: Arial-Regular, Arial;
    font-weight: 400;
    text-align: right;
    height: 24px;
  }
  .promo-code-reward {
    display: flex;
  }
  .promo-code-reward-left {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    padding-bottom: 10px;
    font-family: Arial-Regular, Arial;
    font-size: 16px;
  }
  .promo-code-reward-count {
    font-size: 52px;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    color: #ffffff;
    line-height: 61px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  }
  .promo-code-reward-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 3px;
    padding-top: 2px;
    padding-bottom: 0px;

    .promo-code-reward-right-up {
      font-size: 10px;
      font-family: Arial-Regular, Arial;
      font-weight: 400;
      color: #ffffff;
      line-height: 12px;
    }
    .promo-code-reward-right-down {
      font-size: 20px;
      font-family: Arial-Regular, Arial;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .promo-code-detail {
    display: flex;
    column-gap: 6px;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
    user-select: none;
    & > div {
      font-size: 14px;
      font-family: Arial-Regular, Arial;
      font-weight: 400;
      word-break: break-all;
      color: rgba(255, 255, 255, 0.7);
    }

    & > img {
      transition: all 0.25s;
      transform: rotate(180deg);
    }

    &:hover,
    &:focus {
      & > div {
        transition: all 0.25s;
        color: #fff;
      }
      & > img {
        transition: all 0.25s;
        transform: rotate(180deg);
        content: url("assets/images/promocode/promo_code_details_arrow2.svg");
      }
    }

    &:focus {
      img {
        transition: all 0.25s;
        transform: rotate(360deg);
      }
    }
  }

  //   .promo-code-check {
  //     margin: 0 auto;
  //     align-self: center;

  //     .plusBtn {
  //       padding: unset;
  //       background: #e1e2e5;
  //       border: 2px solid #cbcbcb;

  //       &.is-active {
  //         background: #6153ff;
  //         border: 2px solid #6153ff;
  //       }
  //     }
  //   }

  .no-title {
    color: #cccccc;
    font-size: 18px;
    text-align: center;
  }
}

.confirm-btn {
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  button {
    width: 100%;
  }
}
/deep/ .plusBtn {
  width: 24px;
  height: 24px;
  padding: unset;
  border: 2px solid #6153ff;
  background: #e1e2e5;
  border-radius: 50%;

  &.is-active {
    border: unset;
    background: #6153ff;
    transform: translateY(-2px);
  }
}
.bonus-text {
  margin-right: 10px;
}

.confirm-btn {
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  button {
    width: 100%;
  }
}

.icon-image {
  max-height: 50px;
  vertical-align: bottom;
}

.message {
  height: 28px;
  width: 80%;
  margin: 0 auto;
  text-align: left;

  &.error {
    color: red;
  }
}

span.custom-title {
  font-size: 13px;
}
.error-message {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

// .PAYSSION_WEBMONEY{
//   min-width: 120px;
// }
.payTypes-payment-list {
  .radio-box {
    .list-item {
      :deep(.van-cell__title) {
        display: flex;
        align-items: center;
      }
    }
  }
}

.popup-wrap-de {
  padding: 12px 12px 0px;

  background-color: rgba($color: #1e183f, $alpha: 0.75);
  .popup-title-de {
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    color: white;
  }
}
.server-details-content {
  padding: 16px;
  background-color: rgba($color: #1e183f, $alpha: 0.75);
  color: white;
}

.promo-code-dialog-title {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: left;
  color: #615c78;

  &:first-child {
    margin-top: unset;
  }
}

// .promo-code-dialog-content {
//   display: flex;

.promo-code-check {
  margin: 0 auto;
  align-self: center;

  .plusBtn {
    padding: unset;
    background: #fff;
    border: 2px solid #cbcbcb;

    &.is-active {
      background: #6153ff;
      border: 2px solid #6153ff;
    }
  }
}
// }
</style>